import React, { Component } from 'react';
import { Card, Donut, CardContent, Highcharts, Translate, Spinner, Badge } from '$common';
import CSSModules from 'react-css-modules';
import style from './overview.scss';
import moment from 'moment';
import ActivityMap from '../../activity-map/activity-map';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap_white.css';
import DatePicker from 'react-datepicker';

let colors = [];

const spinnerStyle = {
  position: 'absolute',
  left: '0px',
  right: '0px',
  top: '48%'
};

if (process.muhimma.indexOf(process.target[0]) !== -1) {
  colors = [
    '#706f6f',
    '#f79421'
  ]
} else {
  colors = [
    '#21D9F7',
    '#5757D9'
  ];
}

const audienceIcons = {
  male: require('$shared/images/audience/male.svg'),
  female: require('$shared/images/audience/female.svg'),
  android: require('$shared/images/audience/android.svg'),
  ios: require('$shared/images/audience/ios.svg')
}

@CSSModules(style, { allowMultiple: true })
export default class Overview extends Component {

  state = {
    user_ages: {
      chartType : 'BarChart'
    }
  };

  createDonut() {
    const donut = new Donut(document.getElementById('completion-rate'));
    donut.animateStart();
  }

  componentDidMount() {
    // window.Intercom('trackEvent', 'OPENED_PROJECT', { project_id: this.props.project.id });
    this.createDonut();
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
      this.createDonut();
    }
  }

  get chartConfig() {
    const data = this.props.project.performance_data;

    const totalAccepted = [];
    let accepted = 0;

    const submissions = Object.keys(data).map(key => {
      const date = moment(key, "DD-MM-YYYY").toDate().getTime();
      accepted += parseInt(data[key].accepted_count);
      totalAccepted.push(accepted);
      return [date, data[key].total_count];
    });

    const completionRates = Object.keys(data).map((key, index) => {
      const date = moment(key, "DD-MM-YYYY").toDate().getTime();
      const totalSubmissions = totalAccepted[totalAccepted.length - 1];
      const totalRate = this.props.project.completion_rate;
      const completionRate = parseFloat((totalAccepted[index] * totalRate / totalSubmissions).toFixed(2));
      
      return [date, completionRate];
    });


    return {
      chart: {
        height: 210
      },
      title: false,
      subtitle: false,
      colors: colors,
      xAxis: {
        type: 'datetime'
      },
      yAxis: [
        {
          title: {
            text: ''
          },
          min: 0,
          minRange: 1
        },
        {
          title: {
            text: ''
          },
          opposite: true,
          min: 0,
          labels: {
            format: '{value}%'
          }
        }
      ],
      tooltip: {
        shared: true
      },
      legend: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      credits: false,
      series: [{
          name: 'Submissions',
          yAxis: 0,
          pointInterval: 24 * 3600 * 1000,
          data: submissions
      }, {
          name: 'Completion Rate',
          yAxis: 1,
          pointInterval: 24 * 3600 * 1000,
          data: completionRates
      }]
    }
  }

  get averageAge() {
    const { project } = this.props;
    let averageAge = 0;
    let totalAge = 0;

    if (project.insight) {
      if (project.insight.workers) {
        const ageData = Object.keys(project.insight.workers.ages);
        totalAge = ageData.length;
        ageData.map( age => averageAge += parseInt(age) )
      }
    }

    return averageAge && (averageAge / totalAge).toFixed(2) || null;
  }

  get answerPointsBadgeType() {
    const { project } = this.props;
    if (project.insight.submissions) {
      const averagePoint = project.insight.submissions.average_answer_points;

      if (averagePoint <= 50) {
        return 'error'
      }

      if (averagePoint <= 60) {
        return 'warning'
      }

      if (averagePoint  <= 500) {
        return 'success'
      }
    }
  }

  submissionCountByAudience(audience) {
    const { project } = this.props;
    let count = 0;

    if (project.insight) {
      if (project.insight.workers) {
        Object.keys(project.insight.workers).map( item => {
          if (project.insight.workers[item][audience]) {
            count = project.insight.workers[item][audience];
          }
        })
      }
    }

    return ( <span>{count}</span> );
  }

  render() {
    const { project, activityMap = [] } = this.props;
    const { isDataFetching } = this.state;

    const isFieldCategory = project.project_categories && project.project_categories.find(c => c.id === 35);

    return (
      <div styleName="root">

        {
          project.started_at ?
            <Card styleName="card" header={Translate.get('start_end_dates')} style={{ textAlign: 'center' }}>
              <CardContent>
                <div className="active-range">
                  <DatePicker
                    inline
                    selected={project.started_at && moment(project.started_at) || moment()}
                    minDate={project.started_at && moment(project.started_at) || moment()}
                    maxDate={moment(project.finished_at)}
                    startDate={project.started_at && moment(project.started_at) || moment()}
                    endDate={moment(project.finished_at)}
                  />
                </div>
              </CardContent>
            </Card>
          : null
        }

        <Card styleName="card" header={Translate.get('activity_summary')} style={{ textAlign: 'center' }}>
          <CardContent>
            {
              !isDataFetching ?
                <div styleName="summary-data">
                  <div data-size="180" id={"completion-rate"} data-value={Math.round(project.completion_rate)} />

                  <p styleName="information">
                    <b>{project.tasks_count}</b> {isFieldCategory ? Translate.get('visits_opened') : Translate.get('tasks_opened')},
                    <b>{project.accepted_submissions_count}</b> {Translate.get('submissions_accepted')}.
                  </p>

                  {
                    typeof project.insight !== "undefined" ?
                      typeof project.insight.submissions !== "undefined" ?
                        <p>
                          {Translate.get('average_score')}: &nbsp;
                          <Badge
                            type={this.answerPointsBadgeType}
                          >{project.insight.submissions.average_answer_points}</Badge>
                        </p>
                      : null
                    : null
                  }
                </div>
              : <Spinner block center style={{ ...spinnerStyle }}/>
            }
          </CardContent>
        </Card>

        <Card styleName="card" style={{ textAlign: 'center' }}>
          <CardContent>
            <h2>{Translate.get('audience')}</h2>

            <div styleName="audience">
              {
                Object.keys(audienceIcons).map((item, index) => (
                  <div key={index} styleName="audience-item">
                    <img src={audienceIcons[item]} />
                    {this.submissionCountByAudience(item)}
                  </div>
                ))
              }
            </div>

            {
              this.averageAge ?
                <p>
                  {Translate.get('average_age')}: &nbsp;
                  <Badge type="weak">{this.averageAge}</Badge>
                </p>
              : null
            }

            {
              project.targetings.length > 0 ?
                <div styleName="summary-data">
                  <h2>{Translate.get('targeting_title')}</h2>
                  <div styleName="item-wrapper">
                    {
                      project.targetings.map( (group, index) => (
                        <Tooltip placement="bottom" key={index} overlay={
                          <div>
                            {Translate.get('target_age_range')}: <b>{group.target_group && group.target_group.age_range}</b> <br />
                            {Translate.get('target_gender')}: <b>{group.target_group && Translate.get(group.target_group.gender)}</b> <br />
                            {Translate.get('target_os')}: <b>{group.target_group && Translate.get(group.target_group.os)}</b> <br />
                            {Translate.get('quota')}: <b>{group.max_submission_count && group.max_submission_count-group.active_submissions_count}</b>
                          </div>
                        }>
                          <div styleName="item">{group.target_group && group.target_group.name}</div>
                        </Tooltip>
                      ))
                    }
                  </div>
                </div>
              : null
            }
          </CardContent>
        </Card>

        {
          activityMap.length > 0 ?
            <Card styleName={'card'} header={Translate.get('heat_map')}>
              {activityMap && !isDataFetching ? (
                <ActivityMap points={activityMap} height={`340px`} projectId={project.id} heatmap={true}/>
              ) : <Spinner block center style={{ ...spinnerStyle }}/>}
            </Card>
          : null
        }

        {
          this.chartConfig.series[0].data.length > 0 ?
            <Card styleName={'card half-width'} header={Translate.get('performance')}>
              <CardContent>
                {project.performance_data && !isDataFetching ? (
                  <Highcharts config={this.chartConfig} style={{ paddingTop: '15px' }} />
                ) : <Spinner block center style={{ ...spinnerStyle }}/>}
              </CardContent>
            </Card>
          : null
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/project/show/overview/overview.js